export const MOBILE_VIEW_PORT = '768px';
export const PRIMARY_COLOR = '#51bba6';
export const TEXT_COLOR = '#333';
